export default "325de355bc450955.svg"